import React, { useEffect, useRef, useState } from 'react';
import { AutoComplete, Input, Spin } from 'antd';
import { useLoadScript } from '@react-google-maps/api';
import { getAPIKey } from '@/components/AutoComplete/util';
import { useIntl } from 'umi';
import { EnvironmentOutlined } from '@ant-design/icons';

const GOOGLE_MAPS_API_KEY = getAPIKey();
const LIBRARIES = ["places"]
const GoogleAddressSearch = ({ onChange, onBlur, value }) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [inputValue, setInputValue] = useState(""); // Holds the selected address
  const autocompleteService = useRef(null);
  const placesService = useRef(null);
  const intl = useIntl();


  useEffect(() => {
    if (value)
      handleSearch(value);
  }, [value]);

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    libraries: LIBRARIES,
  });

  useEffect(() => {
    if (isLoaded && window.google) {
      autocompleteService.current = new window.google.maps.places.AutocompleteService();
      placesService.current = new window.google.maps.places.PlacesService(
        document.createElement("div")
      );
    }
  }, [isLoaded]);

  const handleSearch = (inputValue) => {
    setInputValue(inputValue);
    if (!inputValue || !autocompleteService.current) return;
    autocompleteService.current.getPlacePredictions(
      { input: inputValue, types: ["geocode"] },
      (predictions, status) => {
        if (status === window.google.maps.places.PlacesServiceStatus.OK) {
          setOptions(
            predictions.map((p) => ({
              label: p.description,
              value: p.description,
              place_id: p.place_id,
            }))
          );
        }
      }
    );
  };

  const handleSelect = (address, option) => {
    setInputValue(address);
    if (!placesService.current) return;

    placesService.current.getDetails(
      { placeId: option.place_id, fields: ["formatted_address", "geometry", "address_components"] },
      (place, status) => {
        if (status === window.google.maps.places.PlacesServiceStatus.OK) {

          onChange({
            place,
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng()
          });
        }
      }
    );
  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>)=> {
    if (!onBlur) return
    onBlur(e.target.value);
  }
  return (
    <AutoComplete
      options={options}
      onSearch={handleSearch}
      onSelect={handleSelect}
      value={inputValue}
      onBlur={handleBlur}
      onChange={setInputValue}
      style={{ width: "100%" }}
      notFoundContent={loading ? <Spin size="small" /> : null}
    >
      <Input variant={"underlined"} prefix={<EnvironmentOutlined/>} suffix={loading ? <Spin size="small" /> : null} placeholder={intl.formatMessage({
        id: 'component.mapWithAutoComplete.addressPlaceHolder',
        defaultMessage: 'Please enter the address',
      })} />
    </AutoComplete>
  );
};

export default GoogleAddressSearch;
